<template>
  <div
    v-if="enable"
    class="mb-3"
  >
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <Link href="/">
          Главная
        </Link>
      </li>

      <li
        v-for="(item, index) in breadcrumbs"
        :key="index + item.href"
        class="breadcrumb-item"
      >
        <Link :href="item.href">
          {{ item.title }}
        </Link>
      </li>

      <li
        v-if="title"
        class="breadcrumb-item"
      >
        {{ title }}
      </li>
    </ol>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';

export default {
  name: 'UiBreadcrumbs',
  components: { Link },
  props: {
    title: {
      type: String,
      default: '',
    },
    breadcrumbs: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    enable() {
      return this.title || this.breadcrumbs.length;
    },
  },
};
</script>

<style scoped>

</style>
